export default "__VITE_ASSET__Csj9NTeX__"